import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/Services/translation.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private translationService: TranslationService
  ) { }

  ngOnInit() {
    this.translationService.setPageTitle('RankUpPRO');
  }

}
